export default __webpack_public_path__ + "static/media/home-icon.637ddc8a.webp";